import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import permission from './modules/permission'
import company from './modules/company'
import order from './modules/order'
import group from '@/store/modules/group'
import seller from './modules/seller'
import common from '@/store/modules/common'
import client from '@/store/modules/client'
import writer from '@/store/modules/writer'
import expense from '@/store/modules/expense'
import file from '@/store/modules/file'
import task from '@/store/modules/task'
import calender from '@/store/modules/calender'
import dispatcher from '@/store/modules/dispatcher'
import websocket from '@/store/modules/websocket'
import approvals from "@/store/modules/approvals";
import tagsView from "@/store/modules/tagsView";
import todoList from "@/store/modules/todolist";
import myaccount from "@/store/modules/myaccount";
import course from "@/store/modules/course";
import worktop from "@/store/modules/worktop";
import socialmedia from "@/store/modules/socialmedia";
import settlement from './modules/settlement'
import paymentbatch from './modules/paymentbatch'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    paymentbatch,
    settlement,
    myaccount,
    approvals,
    websocket,
    app,
    tagsView,
    settings,
    user,
    permission,
    order,
    company,
    group,
    seller,
    common,
    client,
    writer,
    expense,
    file,
    task,
    dispatcher,
    calender,
    todoList,
    course,
    worktop,
    socialmedia
  },
  getters
})

export default store
